angular.module('SpidApp')

.factory('StickerPDFBuilder', [function () {
    var StickerPDFBuilder = {
        /*
            required parameters:
            - ?
            - agency name
            - ?
            - print date
            - print time
            - price
            - ? G1
            - ? 932810
            - object label (optional)
        */
        generateMock: function () {
            var doc = new jsPDF('landscape', 'mm', [25, 70])

            doc.setFontSize(11)
            doc.setFont("helvetica")
            doc.setFontType("bold")

            var offset = 6

            doc.text(offset + 16, 7, 'ROISSY SPID AP AFGHANISTAN')

            doc.setFontSize(8)
            doc.setFont('courier')
            doc.setFontType('normal')

            doc.text(offset + 11, 6, '93')
            doc.text(offset + 11, 16, '12/02/2016')
            doc.text(offset + 15.5, 19, '19:00:00')
            doc.text(offset + 35, 19, '36.75 EUR')
            doc.text(offset + 11, 22, 'G1')
            doc.text(offset + 21, 22, '932810')
            doc.text(offset + 35, 22, 'Lettre prioritaire'.toUpperCase())

            return doc.output('datauristring')
        },

        /*
            params = {
                  agencyName     : 'ROISSY SPID AP AFGHANISTAN'
                  
                , printDate      : '12/02/2016'
                , printTime      : '19:00:00'
                , price          : '36.75 EUR'
                , stampName      : 'Lettre verte'
            }
        */
        generate: function (params) {
            params = params || {}

            if (!params.agencyName || !params.regate || !params.price || !params.stampName) {
                throw 'StickerPDFBuilder::generate() - Missing parameters'
            }

            var agencyName = params.agencyName
            var regate     = params.regate

            var printDate = null;
            if(params.printDate){
                printDate  = params.printDate;
            }

            var printTime  = null;
            if(params.printTime){
                printTime  = params.printTime;
            }

            var price      = params.price
            var stampName  = params.stampName
            var tag        = params.tag
            var subtag     = params.subtag

//75 x 35 mm
//210 x 99 pt
            var page = {
                height: 180,//180
                width: 180,
                marginTop: 10
            };
            //var doc = new jsPDF('portrait', 'mm', [50,68])

            var fontTitle = {
                fontSize : 40,
                font : "helvetica",
                fontType: "bold"
            };
            var fontNormal = {
                fontSize : 36,
                font : "helvetica",
                fontType: "normal"
            };
            var fontBig = {
                fontSize : 50,
                font : "helvetica",
                fontType: "bold"
            };
            var fontMini = {
                fontSize : 22,
                font : "helvetica",
                fontType: "normal"
            };

            var doc = new jsPDF('portrait', 'mm', [page.width,page.height])

            doc.setFontSize(fontTitle.fontSize);
            doc.setFont(fontTitle.font);
            doc.setFontType(fontTitle.fontType);

            var firstLine = {x:0,y: 60};
            var secondLine = {x:5,y: 80};
            var thirdLine = {x:5,y: 100};
            var fourthLine = {x:5,y:120};
            var nameLine = {x:5,y:140};
            var tagLine = {x:0,y:40};

            doc.text(firstLine.x + 30, firstLine.y, agencyName)

            doc.setFontSize(fontNormal.fontSize);
            doc.setFont(fontNormal.font);
            doc.setFontType(fontNormal.fontType);

            doc.text(firstLine.x+14, firstLine.y, '93')
            if(printDate !== null){
                doc.text(secondLine.x, secondLine.y, printDate)
            }
            if(printTime !== null){
                doc.text(secondLine.x+70, secondLine.y, printTime)
            }
            doc.text(thirdLine.x, thirdLine.y, price)
            doc.text(fourthLine.x , fourthLine.y, 'G1')
            doc.text(fourthLine.x + 35, fourthLine.y, regate)
            doc.text(nameLine.x, nameLine.y, stampName)
            
            if (tag) {
                doc.setFontSize(fontBig.fontSize);
                doc.setFont(fontBig.font);
                doc.setFontType(fontBig.fontType);
                doc.text(tagLine.x, tagLine.y, tag)
            }
            
            if (subtag) {
                doc.setFontSize(fontMini.fontSize);
                doc.setFont(fontMini.font);
                doc.setFontType(fontMini.fontType);
                doc.text(tagLine.x+15, tagLine.y, subtag);
            }

            return doc.output('datauristring')
        }
    }

    return StickerPDFBuilder
}])